<template>
    <div class="max-w-500 w-full min-h-screen mx-auto pb-16 bg-white" data-cy="container_score_overview_main">
        <!-- Header -->
        <TopBarBack title="Overall Score" />
        
        <div class="px-4 py-6">
            <h1 class="text-20 font-bold text-center mb-8 text-a-black-3b3b3b">
                Overall score module - alternative versions
            </h1>
            
            <!-- Score Cards -->
            <div class="space-y-8">
                <!-- Score Card 1: Room for improvement (39/100) -->
                <div class="score-card p-6 bg-white rounded-lg shadow-custom">
                    <div class="flex justify-center mb-6">
                        <CircularGraph
                            :rings="scoreCard1.rings"
                            :score="scoreCard1.score"
                            :maxScore="100"
                            :size="270"
                            :strokeWidth="14"
                            :gap="8"
                            strokeLinecap="butt"
                        />
                    </div>
                    <h2 class="text-18 font-bold text-a-black-3b3b3b mb-2">
                        {{ scoreCard1.title }}
                    </h2>
                    <p class="text-14 text-a-gray-666666 leading-relaxed">
                        {{ scoreCard1.description }}
                    </p>
                </div>
                
                <!-- Score Card 2: Financially coping (55/100) -->
                <div class="score-card p-6 bg-white rounded-lg shadow-custom">
                    <div class="flex justify-center mb-6">
                        <CircularGraph
                            :rings="scoreCard2.rings"
                            :score="scoreCard2.score"
                            :maxScore="100"
                            :size="270"
                            :strokeWidth="14"
                            :gap="8"
                            strokeLinecap="butt"
                        />
                    </div>
                    <h2 class="text-18 font-bold text-a-black-3b3b3b mb-2">
                        {{ scoreCard2.title }}
                    </h2>
                    <p class="text-14 text-a-gray-666666 leading-relaxed">
                        {{ scoreCard2.description }}
                    </p>
                </div>
                
                <!-- Score Card 3: Financially excelling (80/100) -->
                <div class="score-card p-6 bg-white rounded-lg shadow-custom">
                    <div class="flex justify-center mb-6">
                        <CircularGraph
                            :rings="scoreCard3.rings"
                            :score="scoreCard3.score"
                            :maxScore="100"
                            :size="270"
                            :strokeWidth="14"
                            :gap="8"
                            strokeLinecap="butt"
                        />
                    </div>
                    <h2 class="text-18 font-bold text-a-black-3b3b3b mb-2">
                        {{ scoreCard3.title }}
                    </h2>
                    <p class="text-14 text-a-gray-666666 leading-relaxed">
                        {{ scoreCard3.description }}
                    </p>
                </div>
            </div>
            
            <!-- Custom Example Section -->
            <div class="mt-10 p-6 bg-a-blue-f2f5ff rounded-lg">
                <h3 class="text-16 font-bold text-a-blue-2140a6 mb-4">
                    Custom Score Example
                </h3>
                <p class="text-12 text-a-gray-666666 mb-4">
                    You can customize the rings, colors, and values:
                </p>
                <div class="flex justify-center">
                    <CircularGraph
                        :rings="customRings"
                        :score="customScore"
                        :maxScore="100"
                        :size="180"
                        :strokeWidth="12"
                        :gap="5"
                        strokeLinecap="butt"
                        scoreColor="#2140a6"
                    />
                </div>
            </div>
        </div>
        
        <MenuBar />
    </div>
</template>

<script>
import CircularGraph from '@/components/Graph/CircularGraph.vue';
import MenuBar from '@/components/Layout/MenuBar/MenuBar.vue';
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';

export default {
    name: "ScoreOverview",
    components: {
        CircularGraph,
        MenuBar,
        TopBarBack
    },
    data() {
        return {
            // Score Card 1: Room for improvement (39/100)
            scoreCard1: {
                score: 39,
                title: "There's room for improvement",
                description: "Your finances could benefit from some attention. By making small changes to your habits today, you'll set yourself up for significant improvements over time. Start now by checking your scores below and take the first step toward a brighter financial future.",
                rings: [
                    { value: 40, color: '#0064ff', backgroundColor: '#e8eaed' },   // Outer  
                    { value: 55, color: '#002850', backgroundColor: '#e8eaed' },   // Dark blue
                    { value: 30, color: '#7db0ff', backgroundColor: '#e8eaed' },   // Light blue
                    { value: 65, color: '#8eddb2', backgroundColor: '#e8eaed' }    // Inner 
                ]
            },
            
            // Score Card 2: Financially coping (55/100)
            scoreCard2: {
                score: 55,
                title: "You're financially coping",
                description: "You manage your finances well. View your scores below and discover what's working and potential opportunities to improve.",
                rings: [
                    { value: 65, color: '#0064ff', backgroundColor: '#e8eaed' },   // Outer  
                    { value: 40, color: '#002850', backgroundColor: '#e8eaed' },   // Dark blue
                    { value: 85, color: '#7db0ff', backgroundColor: '#e8eaed' },   // Light blue
                    { value: 75, color: '#8eddb2', backgroundColor: '#e8eaed' }    // Inner 
                ]
            },
            
            // Score Card 3: Financially excelling (80/100)
            scoreCard3: {
                score: 80,
                title: "You're financially excelling",
                description: "You're managing your finances well! View your scores below and explore ways to further grow your financial confidence.",
                rings: [
                    { value: 90, color: '#0064ff', backgroundColor: '#e8eaed' },   // Outer  
                    { value: 75, color: '#002850', backgroundColor: '#e8eaed' },   // Dark blue
                    { value: 85, color: '#7db0ff', backgroundColor: '#e8eaed' },   // Light blue
                    { value: 95, color: '#8eddb2', backgroundColor: '#e8eaed' }    // Inner 
                ]
            },
            
            // Custom example
            customScore: 72,
            customRings: [
                { value: 85, color: '#2140a6', backgroundColor: '#f0f1f3' },
                { value: 60, color: '#3dcc6d', backgroundColor: '#f0f1f3' },
                { value: 75, color: '#ff6699', backgroundColor: '#f0f1f3' },
                { value: 90, color: '#ffca66', backgroundColor: '#f0f1f3' }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.score-card {
    border: 1px solid #f0f0f0;
}
</style>
